module.exports = __webpack_public_path__ + "img/000.484804a3.png";